import moment from 'moment-timezone';
import { parsePigrecoUtcDateTime } from './pigrecoDates';

export const getAttestatoPeriod = ({
    modalita,
    participant = {},
    course = {},
    lessons = [],
}) => {
    if (Number(modalita) === 2) {
        // date_start is a calendar date; date_end is a UTC timestamp.
        const start = moment(participant.date_start || '', 'YYYY-MM-DD', true);
        const rawEnd = participant.date_end;
        const validEnd =
            typeof rawEnd === 'string' &&
            moment
                .utc(rawEnd, ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true)
                .isValid();
        const end = validEnd ? parsePigrecoUtcDateTime(rawEnd) : null;
        if (
            Number(participant.perc_course) !== 100 ||
            !start.isValid() ||
            !end ||
            start.format('YYYY-MM-DD') > end.format('YYYY-MM-DD')
        ) {
            const name =
                [participant.Cognome, participant.Nome]
                    .filter(Boolean)
                    .join(' ') || 'partecipante selezionato';
            const error = new Error(
                `Impossibile generare gli attestati: completamento o date PiGreco mancanti/non coerenti per ${name}. Verifica i dati PiGreco prima di riprovare.`
            );
            error.attestatoDateError = true;
            throw error;
        }
        return {
            startText: start.format('DD/MM/YYYY'),
            endText: end.format('DD/MM/YYYY'),
        };
    }

    const start = course.DataInizio || lessons[0]?.Data;
    const end =
        course.DataFine && course.DataFine !== '-'
            ? course.DataFine
            : lessons[lessons.length - 1]?.Data;
    return {
        startText: start
            ? moment(start).format('DD/MM/YYYY')
            : 'DATA INIZIO NON INSERITA',
        endText: end
            ? moment(end).format('DD/MM/YYYY')
            : 'DATA FINE NON INSERITA',
    };
};
